import { ClickEvent, DataDisplayEvent, Label, Layout, TableCell, TableRow, TableRowDisplayEvent } from "@mcleod/components";
import { Alignment, McLeodClassicIntegration, ModelRow, Navigation } from "@mcleod/core";
import { DataFusionListUtil } from "./DataFusionListUtil";
import { TransmissionStatusQuickInfo } from "./TransmissionStatusQuickInfo";
import { AutogenLayoutOutboundTenderList } from "./autogen/AutogenLayoutOutboundTenderList";
import { CommonTooltips } from "@mcleod/common";

export class OutboundTenderList extends AutogenLayoutOutboundTenderList {
    private _searchTendersURL = "lme/datafusion/TenderList?id=";
    private _viewTenderURL = "lme/datafusion/ViewEdiOrder?mode=update&key=";

    setErrorsLabelColor(event) {
        DataFusionListUtil.setErrorsLabelColor(event, true);
    }

    setWarningsLabelColor(event) {
        DataFusionListUtil.setErrorsLabelColor(event, false);
    }

    buttonAdditionalInfoOnClick() {
        const orderId = this.mainDataSource.data[0]?.get("order_id") as string;
        Navigation.navigateTo(this.searchTendersURL + orderId, { newTab: true });
    }

    tableOutboundTendersOnRowDisplay(event: TableRowDisplayEvent) {
        const tableRow = event.getTableRow();
        tableRow.addDblClickListener((event: ClickEvent) => {
            const tableRow = event.target as TableRow;
            const modelRow = tableRow?.data as ModelRow;
            const tenderId = modelRow?.get("id");
            if (tenderId) Navigation.navigateTo(this.viewTenderURL + tenderId, { newTab: true });
        });
        this.setTransmissionStatusQuickInfo(event.getTableRow());

        // Set up error and warning quickinfo tooltips
        const labelErrors = tableRow.findComponentById("labelErrors") as Label;
        const labelWarnings = tableRow.findComponentById("labelWarnings") as Label;

        if (labelErrors) {
            DataFusionListUtil.setStatusErrorTooltipDynamicContent(labelErrors, true);
        }
        if (labelWarnings) {
            DataFusionListUtil.setStatusErrorTooltipDynamicContent(labelWarnings, false);
        }
    }

    openOutTransmissionLogsInClassic(event: ClickEvent) {
        const row = (event.target as TableCell).row as TableRow;
        const partnerId = row.data.get("partner_id");
        const direction = row.data.get("direction");
        const batch = row.data.get("gs06_group_cntlno");
        McLeodClassicIntegration.openClassicScreen("com.tms.client.loadmaster.edi.EntryEdiLog", "<ext> search receiver_id='" + partnerId +
            "' and direction='" + direction + "'" + " and func_batch='" + batch + "' and transaction_type='T'");
    }

    setTransmissionStatusQuickInfo(row: TableRow) {
        const labelTransmission = row.findComponentById("labelTransmission") as Label;
        labelTransmission.tooltipDynamicContent = async () => {
            if (labelTransmission.text !== "Not Sent") {
                const row = labelTransmission.getRelevantModelRow();
                const layout = await Layout.getLoadedLayout("lme/datafusion/TransmissionStatusQuickInfo") as TransmissionStatusQuickInfo;
                await layout.sourceEdiLog?.search({
                    direction: row.get("direction"),
                    func_receiver_id: row.get("partner_id"),
                    receiver_id: row.get("alt_partner_id"),
                    batch: row.get("gs06_group_cntlno"),
                    func_version: row.get("version"),
                    transaction_type: 'T'
                });
                return layout;
            }
            return null;
        }
    }

    displayPartnerName(event) {
        const partnerNameLabel = <Label>event.target;
        const modelRow = this.mainDataSource.activeRow as ModelRow;
        CommonTooltips.setTooltipContentLayout(partnerNameLabel, null, "lme/datafusion/EdiProfileOrderQuickInfo", null,
            {
                "direction": modelRow.get("direction"),
                "partner_id": modelRow.get("partner_id"),
                "alt_partner_id": modelRow.get("alt_partner_id"),
                "version": modelRow.get("version"),
                "batch": modelRow.get("gs06_group_cntlno"),
                "trans_type": 'T',
                "create_date": modelRow.get("create_date")
            }
        );
        partnerNameLabel.tooltipDynamicOptions = { position: Alignment.BOTTOM };
    }

    get searchTendersURL() {
        return this._searchTendersURL;
    }

    get viewTenderURL() {
        return this._viewTenderURL;
    }
}
